import PropTypes from 'prop-types';
import React from 'react';
import { defaultProps } from 'recompose';

import SettingsPage from '@/components/SettingsPage';
import SettingsPageContent from '@/components/SettingsPageContent';
import SettingsPageHeader from '@/components/SettingsPageHeader';
import SettingsPageTitle from '@/components/SettingsPageTitle';

import FormCreate from './Form';

const Form = defaultProps({
  submitButtonText: 'Сохранить бренд',
})(FormCreate);

const EditBrand = ({ isLoaded, itemId, updateBrand }) =>
  isLoaded && (
    <SettingsPage>
      <SettingsPageHeader>
        <SettingsPageTitle>Изменить вопрос</SettingsPageTitle>
      </SettingsPageHeader>
      <SettingsPageContent>
        <Form onSubmit={updateBrand} brandId={itemId} />
      </SettingsPageContent>
    </SettingsPage>
  );

EditBrand.propTypes = {
  isLoaded: PropTypes.bool.isRequired,
  itemId: PropTypes.string.isRequired,
  updateBrand: PropTypes.func.isRequired,
};

export default EditBrand;
